function isLetter(letter) { 
  return /^[a-zA-Z]$/.test(letter); 
}

// ------------------------------
// Word list embedded directly
const wordList = [
  "SHRED","CYCLE","PEDAL","CHAIN","GEARS","SPOKE",
  "CRANK","BRAKE","FORKS","WHEEL","TUBES","CLIPS",
  "TREAD","FRAME","GRIPS","BELLS","LEVER","CABLE",
  "SKIDS","BIKES","PUMPS","TYRES","VALVE","KNOBS",
  "STEMS","AXLES","SHINS","BERMS","JUMPS","HOSES",
  "CLAMP","BIDON","BOOST","CLEAN","EBIKE","FLATS",
  "GOGGS","GRIND","MECHS","SHORE","PUNCH","ROOST",
  "SCRUB","LOAMY","SEIZE","SLABS","TABLE","TACKY",
  "SPECS","TIRES","SENDY","FLIPS","SNACK","BEERS",
  "CAGES","BOLTS","SNIPS","BLEED","POSTS","MOUNT",
  "BROKE","ALLOY","RACES","BUILD","BLING","ROCKS",
  "ROOTS","RAINY","ROTOR","TREND","STYLE","STEEZ",
  "STOKE","PARKS","GARBO","RIDGE","TREES","BENCH",
  "MOSSY","BUILT","FLOAT","SCREW","SAINT","SHOCK",
  "CLICK","STAYS","PIVOT","STEEP","SPEED","BRAPP",
  "GUIDE","CHUTE","SCREE","CREEK","TECHY","DUSTY",
  "BLOWN","SLICK","WHOOP","NORCO","MARIN","GIANT",
  "MULCH","CEDAR","ALDER","CLIFF","BRASH","CRASH",
  "BAILS","TWEAK","WHIPS","CARVE","DRIFT","STALL",
  "ALIGN","BRACE","LINKS","PATCH","ROCKY","MARSH",
  "PRONG","GULLY","BRUSH","THUMP","CRACK","JANKY",
  "LOOSE","SPICY","HUCKS","POPPY","LIPPY","ZESTY",
  "IDLER","KNOLL","BLUFF","SWAMP","FROST","DIRTY",
  "ROWDY","ZIPPY","STOMP","PUMPY","WELDS","PLUGS",
  "SPARE","FLOWY","RACKS","CHILL","TORQX","RINGS",
  "CROWN","STEER","STUDS","PRESS","ZWIFT","TRAIN",
  "TOOLS","FIELD","BREAK","PARTS","SWEET","STEEL",
  "DROPS","REACH","STACK","ANGLE","GUARD","GLOVE",
  "TRAIL","RISER","SOCKS","WATER","SPEND","SHORT",
  "TRACK","ROUND","CREEP","VISOR","SHIFT","CLIMB",
  "JOINT","PANTS","MOSEY","SENDS","ENDOS","KNACK",
  "SPUDS","ROGUE","FRESH","LUBES","BIKER","SCOOT",
  "ROUTE","AIRED","FALLS","BLINE","SKILL","GROMS",
  "METAL","BIKED","ALINE","MUDDY","SPIKE","FIXIE",
  "RIDER","CRIMP","RAINS","CASED","SHIMS","SHOES",
  "STUMP","SMASH","SCENE","SMILE","SCREE","PACKS",
  "SWEAT","WRECK","PLUSH","CRAMP","CRUSH","RIDES",
  "PINCH","GRIME","PROTO","BREWS","CONES","CREAK",
  "CREEK","FREAK","DARCO","DISCS","GRASS","ORING",
  "PAWLS","LOCKS","STOCK","BRAZE","TEETH","WAXED",
  "LIGHT","QUILL","MILES","MUCKY","ELITE","OILED",
  "HILLY","SLIME","LINES","INDEX","SLASH","TAPED"
];

let wordOfTheDay = '';
const guessedLetters = {};
const tiles = Array.from(document.querySelectorAll('.tile'));
const keyButtons = Array.from(document.querySelectorAll('.key'));
let currentRow = 0;

// ------------------------------
// Shuffle helper
function shuffleArray(arr, seed) {
  let array = [...arr];
  let random = mulberry32(seed);
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

// ------------------------------
// Seeded random generator
function mulberry32(a) {
  return function() {
    let t = a += 0x6D2B79F5;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }
}

// ------------------------------
// Initialize daily word (locked to Vancouver time)
function initializeGame() {
  const now = new Date();
  const vancouver = new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Vancouver",
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).formatToParts(now);

  const year = vancouver.find(p => p.type === "year").value;
  const month = vancouver.find(p => p.type === "month").value;
  const day = vancouver.find(p => p.type === "day").value;

  // Build a real Vancouver midnight timestamp
  const today = new Date(`${year}-${month}-${day}T00:00:00-08:00`);

  // Epoch also needs to be Vancouver midnight
  const epoch = new Date('2025-01-01T00:00:00-08:00');

  const daysSinceEpoch = Math.floor((today - epoch) / (1000 * 60 * 60 * 24));

  const cycleLength = wordList.length;
  const cycleNumber = Math.floor(daysSinceEpoch / cycleLength);
  const dayIndex = daysSinceEpoch % cycleLength;

  const shuffledList = shuffleArray(wordList, cycleNumber + 1);
  wordOfTheDay = shuffledList[dayIndex].toUpperCase();

  console.log("Word of the day:", wordOfTheDay);
}



// ------------------------------
// Focus helper
function focusCurrentTile() {
  const rowTiles = tiles.slice(currentRow * 5, currentRow * 5 + 5);
  const firstEmpty = rowTiles.find(t => !t.value);
  if (firstEmpty) firstEmpty.focus({ preventScroll: true });
}

// ------------------------------
// Physical keyboard
document.addEventListener('keydown', e => {
  if (currentRow >= 6) return;

  const rowTiles = tiles.slice(currentRow * 5, currentRow * 5 + 5);
  const firstEmptyIndex = rowTiles.findIndex(t => !t.value);

  if (e.key === 'Backspace') {
    for (let i = 4; i >= 0; i--) {
      if (rowTiles[i].value) {
        rowTiles[i].value = '';
        rowTiles[i].focus({ preventScroll: true });
        break;
      }
    }
  } else if (e.key === 'Enter') {
    checkRowCompletion(currentRow);
  } else if (isLetter(e.key)) {
    if (firstEmptyIndex > -1) {
      rowTiles[firstEmptyIndex].value = e.key.toUpperCase();
      if (firstEmptyIndex < 4) rowTiles[firstEmptyIndex + 1].focus({ preventScroll: true });
    }
  }
});

// ------------------------------
// Virtual keyboard
keyButtons.forEach(key => {
  key.addEventListener('click', () => {
    const letter = key.dataset.letter;
    const action = key.dataset.action;

    if (letter) handleLetter(letter);
    else if (action === 'backspace') handleBackspace(currentRow);
    else if (action === 'enter') checkRowCompletion(currentRow);
  });
});

// ------------------------------
// Virtual helpers
function handleLetter(letter) {
  const rowTiles = tiles.slice(currentRow * 5, currentRow * 5 + 5);
  const emptyTile = rowTiles.find(t => !t.value);
  if (emptyTile) emptyTile.value = letter.toUpperCase();
  focusCurrentTile();
}

function handleBackspace(row) {
  const rowTiles = tiles.slice(row * 5, row * 5 + 5);
  for (let i = 4; i >= 0; i--) {
    if (rowTiles[i].value) {
      rowTiles[i].value = '';
      rowTiles[i].focus({ preventScroll: true });
      break;
    }
  }
}

// ------------------------------
// Check row completion
function checkRowCompletion(row) {
  const rowTiles = tiles.slice(row * 5, row * 5 + 5);
  if (!rowTiles.every(t => t.value)) return alert('🤦🏻 Not enough letters brah 🤦🏻');

  const word = rowTiles.map(t => t.value).join('');
  if (!isValidWord(word)) return alert(`🚫 "${word}" ain't got sh!t to do with bikes broski 🚫`);

  colorTiles(row, word, wordOfTheDay);

  if (word === wordOfTheDay) {
  setTimeout(() => {
    alert(`🎉 Ride On! The word was: ${wordOfTheDay} 🎉`);
  }, 300); // delay to allow time for row to go green
  return;
}

  currentRow = row + 1;
  if (currentRow >= 6) alert(`Game Over! The word was: ${wordOfTheDay}`);
  focusCurrentTile();
}

// ------------------------------
// Validate word against embedded list
function isValidWord(word) {
  return wordList.includes(word.toUpperCase());
}

// ------------------------------
// Color tiles and keyboard
function colorTiles(rowIndex, word, wordOfTheDay) {
  const rowTiles = tiles.slice(rowIndex * 5, rowIndex * 5 + 5);
  const letters = wordOfTheDay.split('');
  const statuses = Array(5).fill('grey');

  // First pass: green
  for (let i = 0; i < 5; i++) {
    if (word[i] === letters[i]) {
      statuses[i] = 'green';
      letters[i] = null;
    }
  }

  // Second pass: orange
  for (let i = 0; i < 5; i++) {
    if (statuses[i] !== 'green') {
      const idx = letters.indexOf(word[i]);
      if (idx > -1) {
        statuses[i] = 'orange';
        letters[idx] = null;
      }
    }
  }

  const colorMap = {green:'#6aaa64', orange:'#c9b458', grey:'#787c7e'};
  rowTiles.forEach((t,i) => {
    t.style.backgroundColor = colorMap[statuses[i]];
    t.style.borderColor = colorMap[statuses[i]];
    t.style.color = 'white';
    // Remember best status for each letter
    guessedLetters[word[i]] = statuses[i]!=='grey' ? statuses[i] : guessedLetters[word[i]] || 'grey';
    updateKeyboard(word[i], guessedLetters[word[i]]);
  });
}

// ------------------------------
// Update keyboard color (monotonic)
function updateKeyboard(letter, status) {
  const btn = document.querySelector(`.key[data-letter="${letter.toUpperCase()}"]`);
  if (!btn) return;

  const currentStatus = btn.dataset.status;
  if (currentStatus === 'green') return;
  if (currentStatus === 'orange' && status !== 'green') return;

  btn.dataset.status = status;
  btn.classList.remove('correct','orange','guessed');

  if (status === 'green') btn.classList.add('correct');
  else if (status === 'orange') btn.classList.add('orange');
  else if (status === 'grey') btn.style.backgroundColor = '#787c7e';
}

// ------------------------------
// Focus first tile on page load
window.addEventListener('DOMContentLoaded', () => {
  tiles.forEach(t => t.value = '');
  initializeGame();
  focusCurrentTile();
});
